<template>
	<div class="area-container">
		<AreaTable :tableData="tableData" :totalCount="totalCount" downloadUrl="/dataModule/areaInfoDownload" ></AreaTable>
	</div>
</template>

<script>
	import AreaTable from './components/AreaTable.vue'
	import {
		fetchAreaList,
	} from '@/utils/api/com'
	export default {
		components: {
			AreaTable
		},
		data() {
			return {
				totalCount: 0,
				tableData: [],
			}
		},
		mounted() {
			this.$store.dispatch('com/resetAreaTableFilter')
		},
		computed: {
			filter() {
				return this.$store.getters.areaTableFilter
			},
		},
		watch: {
			filter() {
				this.getAreaList()
			}
		},
		methods: {
			getAreaList() {
				this.$store.dispatch('com/setAreaTableLoading', true)
				fetchAreaList(this.filter).then(({
					data
				}) => {
					this.tableData = data.datas
					this.totalCount = data.total
				}).finally(() => {
					this.$store.dispatch('com/setAreaTableLoading', false)
				})
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	.area-container {
		height: 100%;
	}
</style>
